module.exports = __webpack_public_path__ + "img/dummy14.c6a868b.jpg";